import dayjs from 'dayjs';
import React, { useEffect } from 'react';

const TIMER_REFRESH_INTERVAL = 1000 as const;

export const calculateRemainingTime = (expiration: number) => {
  const remaining = dayjs(expiration).diff(dayjs(), 'second');
  return remaining >= 0 ? remaining : 0;
};

interface RemainingTimerProps {
  expiration: number;
}

interface RemainingTimerReturn {
  remainingTime: number;
  setExpirationTime: React.Dispatch<React.SetStateAction<number>>;
}

export const useRemainingTimer = ({ expiration }: RemainingTimerProps): RemainingTimerReturn => {
  const [expirationTime, setExpirationTime] = React.useState<number>(expiration);
  const [remainingTime, setRemainingTime] = React.useState<number>(calculateRemainingTime(expirationTime));

  useEffect(() => {
    let timerInterval: ReturnType<typeof setInterval>;
    const remainingTimeWhenUseEffectRun = calculateRemainingTime(expirationTime);

    if (remainingTimeWhenUseEffectRun > 0) {
      setRemainingTime(remainingTimeWhenUseEffectRun);

      timerInterval = setInterval(() => {
        const remainingTimeWhenIntervalRun = calculateRemainingTime(expirationTime);
        setRemainingTime(remainingTimeWhenIntervalRun);

        if (remainingTimeWhenIntervalRun <= 0) {
          clearInterval(timerInterval);
        }
      }, TIMER_REFRESH_INTERVAL);
    }

    return () => {
      if (remainingTimeWhenUseEffectRun > 0) {
        clearInterval(timerInterval);
      }
    };
  }, [expirationTime]);

  return { remainingTime, setExpirationTime };
};
